import useDeviceType from "../common/useDeviceType";

const Event = () => {
  const isMobile = useDeviceType();
  return (
    <div id="event" className=" relative w-full h-full">
      <img
        src={isMobile ? "/images/eventMo.png" : "/images/eventPc.png"}
        alt="event"
      />
    </div>
  );
};

export default Event;
